import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  salesChannelFromModel,
  validateSalesChannelCondition,
  type SalesChannelState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { titleCase } from "@redotech/web-util/strings";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const SALES_CHANNEL = (
  Details: React.ComponentType<ConditionTypeDetailsProps<SalesChannelState>>,
): ConditionType<SalesChannelState, Condition.SalesChannel> => ({
  name: CONDITION_NAMES[Condition.SALES_CHANNEL],
  description(state) {
    if (!state.length) {
      return t("The original order's sales channel");
    }
    const formattedChannels = state.map((string: string) => titleCase(string));
    return t("Original order sales channels: {{channels}}", {
      channels: formattedChannels.join(", "),
    });
  },
  Details(props: ConditionTypeDetailsProps<SalesChannelState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: Condition.SalesChannel) {
    return salesChannelFromModel(model);
  },
  toModel(state) {
    return { type: Condition.SALES_CHANNEL, channels: state };
  },
  valid(state) {
    return validateSalesChannelCondition(state).valid;
  },
});
